import { render, staticRenderFns } from "./NoticeMessagePanel.vue?vue&type=template&id=11d1affe&scoped=true&lang=pug&"
import script from "./NoticeMessagePanel.vue?vue&type=script&lang=ts&"
export * from "./NoticeMessagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeMessagePanel.vue?vue&type=style&index=0&id=11d1affe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d1affe",
  null
  
)

export default component.exports